import type {
  CardioState, CoreState, ProfileState, PushUpsState, WhtrState,
} from '@/features/scoring/lib/types'
import type { TestSessionDraft } from './types'
import { isFieldEntered } from '@/features/scoring/lib/scoringInput'

export interface ScoringFormState {
  profile: ProfileState
  pushUps: PushUpsState
  core: CoreState
  cardio: CardioState
  whtr: WhtrState
}

export function scoringStateToDraft(state: ScoringFormState): TestSessionDraft {
  return {
    profile: { sex: state.profile.sex, age: state.profile.age },
    pushUps: { ...state.pushUps },
    core: { ...state.core },
    cardio: { ...state.cardio },
    whtr: { ...state.whtr },
  }
}

export function draftToScoringState(draft: TestSessionDraft): ScoringFormState {
  const profile = draft.profile ?? { sex: 'male' as const, age: '' }
  const sex = profile.sex === 'female' ? 'female' : 'male'
  const ageRaw = profile.age
  const age = (ageRaw != null && String(ageRaw).trim() !== '') ? String(ageRaw) : ''

  const pushUps = { type: 'standard', reps: '', exempt: false, ...draft.pushUps } as PushUpsState
  const core = {
    type: 'situp', reps: '', plankMin: '', plankSec: '', exempt: false, ...draft.core,
  } as CoreState
  const cardio = {
    type: 'run', runMin: '', runSec: '', shuttles: '', exempt: false, ...draft.cardio,
  } as CardioState
  const whtr = { waist: '', height: '', exempt: false, ...draft.whtr } as WhtrState

  return { profile: { sex, age }, pushUps, core, cardio, whtr }
}

/** True when the draft has any entered value or exemption toggle. */
export function hasDraftContent(draft: TestSessionDraft): boolean {
  const pushUps = draft.pushUps as unknown as PushUpsState
  const core = draft.core as unknown as CoreState
  const cardio = draft.cardio as unknown as CardioState
  const whtr = draft.whtr as unknown as WhtrState
  const age = draft.profile?.age

  if (pushUps.exempt || core.exempt || cardio.exempt || whtr.exempt) return true
  if (isFieldEntered(age)) return true
  if (isFieldEntered(pushUps.reps)) return true
  if (isFieldEntered(core.reps) || isFieldEntered(core.plankMin) || isFieldEntered(core.plankSec)) return true
  if (isFieldEntered(cardio.runMin) || isFieldEntered(cardio.runSec) || isFieldEntered(cardio.shuttles)) return true
  if (isFieldEntered(whtr.waist) || isFieldEntered(whtr.height)) return true
  return false
}